var map = {
	"./icons-40-perks-beach-office.svg": "19e9",
	"./icons-40-perks-personal-growth.svg": "88a4",
	"./icons-40-perks-testing-fun.svg": "87f9",
	"./icons-40-perks-think-big.svg": "f260",
	"./icons-40-perks-we-are-flat.svg": "0aad",
	"./icons-40-perks-we-are-foodies.svg": "619a",
	"./icons-40-perks-why-so-serious.svg": "fd2b",
	"./icons-40-perks-work-hard.svg": "1b86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b1f";